import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GoogleChartServiceModule } from './service/google-chart.service.module';
import { LineChartComponent } from './line-chart/line-chart.component'



@NgModule({
  declarations: [LineChartComponent],
  imports: [
    CommonModule,
    GoogleChartServiceModule
  ],
  exports: [LineChartComponent],
  providers : []
})
export class GoogleChartModule { }
